import request from "../utils/request";

function get(params) {
    return request({
        url: "/message/get",
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
}

function create(data) {
    return request({
        url: "/message/add",
        method: "POST",
        data: data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
    })
}

function update(data, id) {
    return request({
        url: `/message/${id}`,
        method: "PUT",
        data: data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
    })
}

function remove(id) {
    return request({
        url: `/message/${id}`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
    })
}

function addNotiRequest(data) {
    return request({
        url: `/notification-request/add`,
        method: "POST",
        data: data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
    })
}

function getSearchQuery(params) {
    return request({
        url: "/search-query/get",
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        params: params
    })
}

const MessageService = {
    get,
    create,
    update,
    remove,
    addNotiRequest,
    getSearchQuery
};

export default MessageService;